module.exports = __webpack_public_path__ + "img/purchases--icon.d28e22c0.svg";